import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'distinct'
})
export class DistinctPipe implements PipeTransform {
  
  transform<T>(value: T[], field: string): T[] {
    if (value) {
      const ids = value.map(v => v[field]);
      return value.filter((v, i) => ids.indexOf(v[field]) === i);
    } else {
      return value;
    }
  }
}
